<!--
 * @Author: your name
 * @Date: 2021-08-09 15:14:26
 * @LastEditTime: 2022-01-26 16:33:57
 * @LastEditors: DESKTOP-0USOKJQ
 * @Description: In User Settings Edit
 * @FilePath: \sp-site-front\src\views\layout\components\top.vue
-->
<template>
    <div class="personal_content_public">
        <top :customer="customer" />
        <perHeader :customer="customer" />
        <div class="personal">
            <div class="personal_aside">
                <ul>
                    <li class="per_list_title">
                        <router-link to="">订单中心</router-link>
                    </li>
                    <li v-bind:class="{'select_li': checkIsAction('myOrder')}">
                        <router-link :to="{path: '/personal/myOrder', query: {}}"><span class="strokeDiv">我的订单</span></router-link>
                    </li>
                    <li v-bind:class="{'select_li': checkIsAction('sampleOrder')}">
                        <router-link :to="{path: '/personal/sampleOrder', query: {}}"><span class="strokeDiv">我的样品单</span></router-link>
                    </li>
                    <li v-bind:class="{'select_li': checkIsAction('DeliveryList')}">
                        <router-link :to="{path: '/personal/DeliveryList', query: {}}"><span class="strokeDiv">我的送货单</span></router-link>
                    </li>
                    <li class="per_list_title">
                        <router-link to="">财务中心</router-link>
                    </li>
                    <li v-bind:class="{'select_li': checkIsAction('Remittance')}"><router-link :to="{path: '/personal/Remittance', query: {}}"><span class="strokeDiv">汇款账号</span></router-link></li>
                    <li v-bind:class="{'select_li': checkIsAction('accountStatement')}">
                        <router-link :to="{path: '/personal/accountStatement', query: {}}"><span class="strokeDiv">我的对账单</span></router-link>
                    </li>
                    <li v-bind:class="{'select_li': checkIsAction('invoice')}">
                        <router-link :to="{path: '/personal/invoice', query: {}}"><span class="strokeDiv">开票资料</span></router-link>
                    </li>
                    <li class="per_list_title">
                        <router-link to="">关注中心</router-link>
                    </li>
                    <li v-bind:class="{'select_li': checkIsAction('purchaseRecord')}">
                        <router-link :to="{path: '/personal/purchaseRecord', query: {}}"><span class="strokeDiv">购买记录</span></router-link>
                    </li>
                    <li v-bind:class="{'select_li': checkIsAction('collection_list')}">
                        <router-link :to="{path: '/personal/collection_list', query: {}}"><span class="strokeDiv">我的收藏</span></router-link>
                    </li>
                    <li class="per_list_title">
                        <router-link to="">售后服务</router-link>
                    </li>
                    <li v-bind:class="{'select_li': checkIsAction('backGoods')}">
                        <router-link :to="{path: '/personal/backGoods', query: {}}"><span class="strokeDiv">我的退货</span></router-link>
                    </li>
                    <li v-bind:class="{'select_li': checkIsAction('suggest')}">
                        <router-link :to="{path: '/personal/suggest', query: {}}"><span class="strokeDiv">建议反馈</span></router-link>
                    </li>
                    <li class="per_list_title">
                        <router-link to="">账户管理</router-link>
                    </li>
                    <li v-bind:class="{'select_li': checkIsAction('accountInfo')}">
                        <router-link :to="{path: '/personal/accountInfo', query: {}}"><span class="strokeDiv">账户信息</span></router-link>
                    </li>
                    <li v-bind:class="{'select_li': checkIsAction('receivingAddress')}">
                        <router-link :to="{path: '/personal/receivingAddress', query: {}}" class="strokeDiv"><span>收货地址</span></router-link>
                    </li>
                    <li v-bind:class="{'select_li': checkIsAction('enterprise')}">
                        <router-link :to="{path: '/personal/enterprise', query: {}}"><span class="strokeDiv">企业信息</span></router-link>
                    </li>
                    <li v-bind:class="{'select_li': checkIsAction('subAccount')}" v-if="customer.isAllowChild">
                        <router-link :to="{path: '/personal/subAccount', query: {}}"><span class="strokeDiv">子账号管理</span></router-link>
                    </li>
                </ul>
            </div>
            <router-view :customer="customer" />
        </div>
        <FooterInfo />
        <right-aside fromPages="personal" />
    </div>
</template>
<script>
import top from "@/components/pageComponents/top.vue";
import perHeader from "@/components/personal/perHeader.vue";
import FooterInfo from "@/components/pageComponents/footer.vue";
import personalIndex from "./personal.vue";
import RightAside from "../../components/pageComponents/rightAside.vue";

export default {
    components: { top, FooterInfo, personalIndex, perHeader, RightAside },
    data() {
        return {
            customer: { isAllowChild: false, fullName: null, fromPage: null },
        };
    },
    methods: {
        checkIsAction: function (v) {
            if (window.location.pathname.indexOf(v) > 0) {
                return true;
            }
            return false;
        },
    },
};
</script>
<style scoped>
.personal_content_public {
    min-width: 1200px;
    background-color: #f4f4f4;
}
/* 个人中心-左边 */
.personal {
    width: 1200px;
    margin: 0 auto 50px;
    display: flex;
    justify-content: flex-start;
}
.personal_aside {
    width: 224px;
    background-color: #ffffff;
    border: 1px solid #f3f3f3;
}
.personal_aside ul li a {
    width: 100%;
    display: inline-block;
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    text-align: center;
    margin-top: 20px;
    cursor: pointer;
}
.personal_aside ul li:nth-child(1) a {
    margin-top: 0;
}
.personal_aside ul .per_list_title a {
    font-size: 15px;
    border-top: 1px solid #f3f3f3;
    padding-top: 20px;
    font-weight: bold;
    cursor: default;
}
.personal_aside {
    height: 825px;
    margin-bottom: 50px;
    margin-right: 15px;
}
.personal_aside ul {
    margin-top: 0;
    padding-bottom: 25px;
}
.select_li > a {
    color: #e1251b !important;
}
</style>


// WEBPACK FOOTER //
// src/views/personal/index.vue